(function($, Cobalt, undefined) {
    Cobalt.Widget = {
        editingEnabled: false,
        widgetAreaWorkspaceID: "widget-area-workspace",
        widgetAreaWorkspaceSelector: "#widget-area-workspace",
        widgetTrashbinSelector: "#widget-trash-bin",
        widgetTrashbinID: "widget-trash-bin",
        initialize: function() {
            Cobalt.Widget.createSettings();
        },
        createSettings: function() {
            if (this.settings != null) return;

            this.settings = new Object();
            this.settings.widgetSelector = '.widget';
            this.settings.styleDragging = 'dragging';
            this.settings.widgetPlaceSelector = '.widget-place';
            this.settings.widgetPlaceLockedSelector = '.widget-place-locked';

            var that = this;
            this.callbacks = {
                onUpdated: function() {
                    var pos = that.serializeWidgetPositions();
                    $(that.settings.placementFieldId).val(pos);
                }
            };
        },
        allAreas: null,
        highlightAcceptableAreas: function(widget) {
            var classes = widget.attr("class");
            var disableAreas = this.allAreas.slice(0);
            var classArray = classes.split(/ /);
            var allowedRegex = new RegExp(/widget-allowed/);
            for (var i in classArray) {
                var match = allowedRegex.exec(classArray[i]);
                if (match) {
                    var areaId = classArray[i].replace(allowedRegex, '#widget-area');
                    disableAreas = jQuery.grep(disableAreas, function(value) {
                        return value != areaId;
                    });
                }
            }
            $(disableAreas.join(',')).sortable('disable');

            var dashboardArea = $("#widget-area-dashboard");
            var dashboardDisabled = dashboardArea.length > 0 && dashboardArea.find(".widget").length >= 3 && widget.parents(dashboardArea.selector).length <= 0;
            if (dashboardDisabled) {
                dashboardArea.sortable('disable');
            }
        },
        unhighlightAcceptableAreas: function() {
            $('.widget-place').sortable('enable');
        },
        activateWidgets: function() {
            var that = this;
            var widgetPlaces = $(that.settings.widgetPlaceSelector);
            this.allAreas = new Array();
            var thoseAreas = this.allAreas;
            widgetPlaces.each(function() {
                var placeId = $(this).attr('id');
                if (placeId != that.widgetAreaWorkspaceID) {
                    thoseAreas.push('#' + placeId);
                }
            });
            widgetPlaces.sortable({
                connectWith: that.settings.widgetPlaceSelector,
                placeholder: 'widget-placeholder',
                //just get items that are not locked
                items: '.widget:not(.widget-widget-locked)',
                start: function(event, ui) {
                    // No editing locked widget places
                    if ($(ui.item).parents('.widget-place-locked').length > 0) {
                        return false;
                    }
                    ui.item.addClass(that.settings.styleDragging);
                },
                stop: function(event, ui) {
                    var validPlacement = true;

                    var dashboardPlacement = $(ui.item).parents("#widget-area-dashboard");
                    if (dashboardPlacement.length > 0 && dashboardPlacement.find(".widget").length > 3) {
                        validPlacement = false;
                    }
                    if ($(ui.item).parents('.disallowed').length > 0) {
                        validPlacement = false;
                    }
                    ui.item.removeClass(that.settings.styleDragging);
                    if (validPlacement) {
                        if ($(ui.item).parents(".widget-place").length < 1) {
                            $(Cobalt.Widget.widgetAreaWorkspaceSelector).append($(ui.item));
                        }
                        if ($.isFunction(that.callbacks.onUpdated)) {
                            that.callbacks.onUpdated();
                        }
                    } else {
                        return false;
                    }
                }
            });

            $(that.settings.widgetSelector).mousedown(function() {
                that.highlightAcceptableAreas($(this));
                if ($(this).parents('.widget-place-locked').length == 0) {
                    $(that.settings.widgetPlaceSelector).addClass("widget-place-editable");
                }
            });

            $('body').mouseup(function() {
                that.unhighlightAcceptableAreas();
                $(that.settings.widgetPlaceSelector).removeClass("widget-place-editable");
            });

        },
        deactivateWidgets: function() {
            $(this.settings.widgetPlaceSelector).sortable('disable');
        },
        serializeWidgetPositions: function() {
            var places = new Array();
            var i = 0;
            var that = this;
            $(this.settings.widgetPlaceSelector + ',' + this.settings.widgetPlaceLockedSelector).each(function() {
                var widgetPlace = this;
                var id = $(widgetPlace).attr("id");
                if (id == Cobalt.Widget.widgetAreaWorkspaceID || id == Cobalt.Widget.widgetTrashbinID) {
                    return;
                }
                var widgets = new Array();
                var j = 0;
                $(this).find(that.settings.widgetSelector).each(function() {
                    widgets[j++] = $(this)[0].id;
                });
                places[i++] = $(this)[0].id + '=' + widgets.join(',');
            });

            return places.join('|');
        },
        initializeStaticEditor: function(widgetListId, placementFieldId, defaultWidgetIDs) {
            $(widgetListId).hide();
            this.createSettings();
            this.settings.placementFieldId = placementFieldId;

            this.activateWidgets();

            Cobalt.Widget.nextWidgetPlacementID = 0;
            $(widgetListId).find("option").each(function(i, val) {
                if ($(val).val() != "") {
                    var widgetID = $(val).val();
                    var addWidget = true;
                    $(defaultWidgetIDs).each(function(i, val) {
                        if (val == widgetID) {
                            addWidget = false;
                        }
                    });
                    if (addWidget) {
                        var widgetClass = $(this).attr('data-widget-class');
                        Cobalt.Widget.createWidget(false, null, widgetID, $(val).text(), Cobalt.Widget.widgetAreaWorkspaceID, null, widgetClass);
                    }
                }
            });
        },
        getWidgetSelector: function(templateID, siteID, callback) {
            var widgetSelection = $("#widget-selection");
            if (widgetSelection != undefined && widgetSelection.length > 0) {
                $.ajax({
                    url: Cobalt.Routes.Instance.GuildGetWidgetSelector() + "?templateID=" + templateID + "&siteID=" + siteID,
                    success: function(results) {
                        $(widgetSelection).empty();
                        $(widgetSelection).html(results);
                        $('.accordion').accordion({
                            clearStyle: true,
                            autoHeight: false
                        });
                        if (callback) {
                            callback();
                        }
                    }
                });
            }
        },
        createWidget: function(renderEditLink, siteWidgetMapID, widgetID, widgetName, parentID, wpID, cssClass) {
            if (widgetID == null || widgetID == 0) return;

            $("#field-AvailableWidgets option[value='" + widgetID + "']").remove();
            if (wpID == null) {
                wpID = "+" + Cobalt.Widget.nextWidgetPlacementID++;
            }
            var widgetDiv = $("<div class=\"divborder widget\">")
            if (cssClass) {
                widgetDiv.addClass(cssClass);
            }

            var widgetIDentifier = 'w-' + widgetID + '_' + wpID;
            widgetDiv.attr("id", widgetIDentifier);

            var widgetHeader = $("<div class=\"divheader widget-header\">").append($("<span>").append(widgetName).append(" "));
            var widgetMenu = $("<div class=\"widget-menu\">");
            if (renderEditLink) {
                widgetMenu.append($("<a>").attr("href", Cobalt.Routes.Instance.ControlPanelWidgetSettings(siteWidgetMapID)).append($('<span class="icon edit">')));
            }
            var that = this;
            var closeLink = $('<span class="icon cancel">').click(function() {
                $(this).parents(that.settings.widgetSelector).remove();
                that.callbacks.onUpdated();
            });
            widgetHeader.append(widgetMenu);

            var widgetContent = $("<div class=\"divcontent widget-content\">").append("(" + L.GuildSite.GuildRegistration.WidgetContent() + ")");
            widgetDiv.append(widgetHeader).append(widgetContent);

            this.addWidget(widgetDiv, parentID);

            this.callbacks.onUpdated();
        },
        addWidget: function(widgetContent, containerId) {
            var targetContainer = $('#' + containerId);
            if (targetContainer.length > 0) {
                targetContainer.append(widgetContent);
            }
            else {
                $("#widget-area-workspace").append(widgetContent);
            }
            this.activateWidgets();
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Widget.js